import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, LogOut } from 'lucide-react';
import ConfirmationModal from './ConfirmationModal';
import { forgetShowSession } from '../lib/showSession';

export default function Sidebar({ isOpen, closeSidebar }) {
    const navigate = useNavigate();
    const sidebarRef = useRef(null);
    const overlayRef = useRef(null);
    const [confirmLogout, setConfirmLogout] = useState({ show: false, message: "" });

    useEffect(() => {
        if (isOpen) {
            sidebarRef.current.style.transform = 'translateX(0%)';
            overlayRef.current.style.display = 'block';
        } else {
            sidebarRef.current.style.transform = 'translateX(-100%)';
            overlayRef.current.style.display = 'none';
        }
    }, [isOpen]);

    const navigateTo = (route) => {
        closeSidebar();
        navigate(route);
    };

    const handleLogout = () => {
        setConfirmLogout({ show: true, message: "Tem certeza de que deseja sair?" });
    };

    const executeLogout = () => {
        forgetShowSession();
        setConfirmLogout({ show: false, message: "" });
        localStorage.removeItem('token');
        window.location.href = "/";
    };

    const cancelLogout = () => {
        setConfirmLogout({ show: false, message: "" });
    };

    return (
        <>
            <ConfirmationModal show={confirmLogout.show} message={confirmLogout.message} onConfirm={executeLogout} onCancel={cancelLogout} />
            {/* 🔹 Overlay para fechar ao clicar fora */}
            <div ref={overlayRef} onClick={closeSidebar} style={overlayStyle}></div>

            <div ref={sidebarRef} style={sidebarStyle}>
                {/* Botão de fechar Sidebar */}
                <button onClick={closeSidebar} style={closeButtonStyle}>
                    <X size={28} color="black" />
                </button>

                <h2 style={titleStyle}>Menu</h2>

                <button onClick={() => navigateTo('/home')} style={buttonStyle}>Home</button>
                <button onClick={() => navigateTo('/profile')} style={buttonStyle}>Perfil</button>
                <button onClick={() => navigateTo('/history')} style={buttonStyle}>Histórico</button>
                <button onClick={() => navigateTo('/payments')} style={buttonStyle}>Pagamentos</button>

                {/* 🚀 Botão de Logout */}
                <button onClick={handleLogout} style={logoutButtonStyle}>
                    <LogOut size={24} color="white" />
                    Sair
                </button>
            </div>
        </>
    );
}

// 🔹 Estilos inline corrigidos
const sidebarStyle = {
    position: 'fixed',
    top: '60px', // ✅ Agora começa abaixo da Navbar
    left: 0,
    width: '60%',
    height: 'calc(100% - 60px)', // ✅ Ajusta para o tamanho certo
    backgroundColor: '#fff',
    padding: '20px',
    transition: 'transform 0.3s ease-in-out',
    boxShadow: '2px 0px 10px rgba(0,0,0,0.2)',
    zIndex: 1000,
    transform: 'translateX(-100%)', // 🚀 Começa escondida totalmente fora da tela
};

const overlayStyle = {
    position: 'fixed',
    top: '60px', // ✅ Começa abaixo da Navbar
    left: 0,
    width: '100%',
    height: 'calc(100% - 60px)', // ✅ Ajusta altura correta
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    display: 'none',
    zIndex: 999,
};

const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '24px',
    cursor: 'pointer',
    float: 'right',
    marginBottom: '20px',
};

const titleStyle = { fontSize: '20px', fontWeight: 'bold', marginBottom: '20px' };

const buttonStyle = {
    width: '100%',
    padding: '15px',
    border: 'none',
    borderBottom: '1px solid #ddd',
    background: 'none',
    fontSize: '18px',
    color: '#333',
    textAlign: 'left',
    cursor: 'pointer',
};

const logoutButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    backgroundColor: '#E60000',
    color: 'white',
    padding: '10px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '20px',
    width: '100%',
};
